"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Bitcoin, Cuboid, TrendingUp } from "lucide-react";
const features = [{
  icon: Bitcoin,
  title: "FUNDADA\nEN 1979\n"
}, {
  icon: Cuboid,
  title: "500+\nEmpleados"
}, {
  icon: TrendingUp,
  title: "Presencia\nGlobal"
}];
export default function HeroBanner() {
  return <section data-section-id="258045" id="hero-banner" className="bg-background text-foreground min-h-screen flex flex-col items-center justify-center py-24 px-6 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-3xl blur-[100px] pointer-events-none" />

      <div className="max-w-5xl w-full mx-auto flex flex-col items-center relative z-10">
        {}
        <Link to="/HomePage#" className="mb-12 hover:opacity-80 transition-opacity">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_acero_logo.png" alt="Kalisch Acero Logo" className="h-16 object-contain" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_acero_logo.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_acero_logo.png-wvc-sizes" />
        </Link>

        {}
        <div className="text-center mb-8">
          <h1 className="font-default font-extrabold text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-tighter flex flex-col items-center">
            <span className="text-foreground drop-shadow-md">
              KALISCH
            </span>
            <span className="bg-gradient-to-b from-primary via-primary-600 to-primary-800 bg-clip-text text-transparent drop-shadow-lg pb-2">
              ACERO
            </span>
          </h1>
        </div>

        {}
        <p className="text-muted-foreground text-sm md:text-base lg:text-lg tracking-[0.25em] uppercase text-center font-medium mb-20 max-w-2xl">
          Liderazgo Industrial. Calidad de Acero. Valor Sostenible.
        </p>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 w-full mb-24">
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-card border-border shadow-md backdrop-blur-sm hover:bg-muted transition-colors duration-300">
              <CardContent className="pt-8 pb-8 flex flex-col items-center text-center gap-6">
                <div className="size-20 rounded-lg border-2 border-primary flex items-center justify-center bg-background shadow-sm relative group overflow-hidden">
                  <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <feature.icon className="size-10 text-primary relative z-10" strokeWidth={1.5} />
                </div>
                <h3 className="font-default font-bold text-lg md:text-xl uppercase tracking-wider text-foreground whitespace-pre-line leading-tight">
                  {feature.title}
                </h3>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="flex items-center justify-center gap-4 md:gap-8 w-full max-w-2xl mx-auto">
          <Separator className="flex-1 bg-accent/60 h-[2px]" />
          <span className="text-accent tracking-[0.3em] uppercase font-bold text-sm md:text-base whitespace-nowrap drop-shadow-sm">
            Excelencia en Acero
          </span>
          <Separator className="flex-1 bg-accent/60 h-[2px]" />
        </div>
      </div>
    </section>;
}